class CurrencyConverter {
    constructor() {
        // this.fromCurrency = document.querySelector('form.converter-block__form input[name="first"]');
        // this.fromCurrencySelect = document.querySelector('#fromCurrencySelect');
        // this.toCurrency = document.querySelector('form.converter-block__form input[name="second"]');
        // this.toCurrencySelect = document.querySelector('#toCurrencySelect');
        this.bankOptions = document.querySelectorAll('.currencies__rates_tabs_item');
        this.convertButton = document.querySelector('#convert-button');
        this.currencyForm = document.querySelector('.converter-block__form');
        this.amountInput =  document.querySelector('#amount');

        // this.fromCurrency.addEventListener('click', this.openDropdown.bind(this));
        this.bankOptions.forEach((option) => {
            option.addEventListener('click', this.changeBank.bind(this));
        });

        // this.convertButton.addEventListener('click', this.convert.bind(this));
        this.currencyForm.addEventListener('submit',  this.convert.bind(this));
        this.amountInput.addEventListener('blur',  this.convert.bind(this));
        this.availableFlags = ["usd", "eur", "pln", "gbp", "chf", "cad", "aud", "cny", "jpy", "try", "uah"]

    }

    addToURL(param, value) {
        //     add value to url
        const url = new URL(window.location.href);
        url.searchParams.set(param, value);
        window.history.pushState({}, '', url);
    }

    renewCurrencyDropdowns(currenciesList) {
        document.querySelectorAll('.converter-dropdown').forEach((item, i) => {
            const selectedBtn = item.querySelector('.converter-dropdown__btn');
            const selected_curr = item.querySelector('.converter-dropdown__btn-text');
           
            if (!currenciesList.includes(selected_curr.textContent.toLowerCase())) {
                
                const value = selected_curr.getAttribute('id') === 'from-currency' ? 'usd' : 'uah'
                selectedBtn.dataset.value = value;
                selected_curr.dataset.value = value;
                selected_curr.innerHTML = `<span class="converter-dropdown__flag"><img src="/static/news/img/technical-pages/flags/${value}.svg" alt="${value}" /></span>${value.toUpperCase()}`
            }

            const select = item.querySelector('.converter-dropdown__content');
            select.innerHTML = '';
            currenciesList.forEach((currency) => {
                const option = document.createElement('span');
                const optionTitle = document.createElement('span');
                optionTitle.textContent = currency.toUpperCase();
                const flagIcon = document.createElement('span');
                flagIcon.classList.add('converter-dropdown__flag');

                if(this.availableFlags.includes(currency.toLowerCase())) {
                    flagIcon.innerHTML = `<img src=/static/news/img/technical-pages/flags/${currency.toLowerCase()}.svg alt=${ currency.toUpperCase()} />`
                }

                option.dataset.value = currency;
                option.append(flagIcon);
                option.append(optionTitle);
                option.classList.add('converter-dropdown__item');
                select.appendChild(option);
            })
        })

    }

    changeBank(event) {
        this.bankOptions.forEach(item => {
            item.classList.remove('tabs__item_active');
        })
        event.target.classList.add('tabs__item_active');
        let bank = event.target.dataset.value;
        this.addToURL('bank', bank);
        fetch(`/api/currencies/bank_currencies?bank=${bank}`)
            .then((response) => response.json())
            .then((data) => {
                this.renewCurrencyDropdowns(data.currencies);
                this.convert({ preventDefault: () => {} });
            })
    }

    convert(event) {
        event.preventDefault();
        const url = new URL(window.location.href);

        const amount = document.querySelector('#amount').value;

        if(amount) {
            const fromCurrency = document.querySelector('#from-currency').dataset.value;
            const toCurrency = document.querySelector('#to-currency').dataset.value;
            const bank = url.searchParams.get('bank') || 'international';
            const date = url.searchParams.get('date') || '';

            fetch(`/api/currencies/convert?from=${fromCurrency}&to=${toCurrency}&amount=${amount}&bank=${bank}&date=${date}`)
                .then((response) => response.json())
                .then((data) => {
                    // remain only two signs after dot
                    const result = (+data.converted_amount).toFixed(2);
                    document.querySelector('#converted-amount').value = result;
                })
        } else {
            document.querySelector('#converted-amount').value = 0;
        }
    }
}

export const currencyConverter = new CurrencyConverter();
